import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    HostListener,
    OnInit,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {InactivityService} from "./lib/services/inactivity/inactivity.service";
// import {TestExportComponent} from "payments/TestExportComponent";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {MenuService} from "./lib/services/menu/menu.service";
import {AuthService} from "./lib/services/auth/auth.service";
import {StorageKeysEnum} from './lib/storage/storage-keys.enum';
import {ToastService} from "./lib/services/toast/toast.service";
import {GeolocationService} from "./lib/services/geolocation/geolocation.service";
import {RcpService} from "./lib/services/rcp/rcp.service";
import {FraudProtectionService} from "./lib/services/fraud-protection/fraud-protection.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
    title = 'host';
    selectedLanguage = "es";
    private routerEventsSubscription!: Subscription;

    constructor(
        private translate: TranslateService,
        private inactivityService: InactivityService,
        private authService: AuthService,
        private router: Router,
        private menuService: MenuService,
        private toastService: ToastService,
        private geolocationService: GeolocationService,
        private rcpService: RcpService,
        private cdr: ChangeDetectorRef,
        private fraudProtectionService :FraudProtectionService
    ) {
        this.translate.addLangs(["en", "es", "fr", "de", "zh", "ja", "ko"]);
        const browserLang = translate.getBrowserLang();
        const sessionLang = sessionStorage.getItem(StorageKeysEnum.CURRENT_LANGUAGE)
        let lang = sessionLang ? sessionLang : (browserLang?.match(/es|en/) ? browserLang : "es");
        sessionStorage.setItem(StorageKeysEnum.CURRENT_LANGUAGE, lang)
        this.switchLang(lang);
    }

    switchLang(lang: string) {
        this.translate.use(lang);
    }

    ngOnInit(): void {
        this.geolocationService.hasLocationPermission().subscribe(hasLocation => {
            if (hasLocation) {
                if (this.authService.hasTokens()) {
                    if (!this.rcpService.isTemporalPassword()) {
                        this.authService.validateTokenSession().subscribe(response => {
                            this.inactivityService.startSessionTimer()
                            this.cdr.detectChanges();
                        })
                    }
                }
            }
            this.routerEventsSubscription = this.router.events
                .pipe(filter(event => event instanceof NavigationEnd))
                .subscribe((event: any) => {
                    let url = event.url;
                    this.menuService.validateMenu(url);
                });
        })
        let fraudProtectionAuth = sessionStorage.getItem('FP_AUTHORIZED') || '';
        if (!fraudProtectionAuth && fraudProtectionAuth != 'true'){
            this.fraudProtectionService.fetchFraudConfig()
        }
    }


    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (this.authService.hasTokens()) {
            this.inactivityService.resetSessionTimer();
        }

    }

    @HostListener('document:keydown', ['$event'])
    onDocumentKeydown(event: KeyboardEvent) {
        if (this.authService.hasTokens()) {
            this.inactivityService.resetSessionTimer();
        }
    }


    ngOnDestroy() {
        // this.tokenExpiredTimerservice.logoutTimerExpired.unsubscribe()
    }

    @ViewChild('testComponent', {read: ViewContainerRef})
    viewContainer!: ViewContainerRef;

    load() {
        //  this.viewContainer.createComponent(TestExportComponent);
    }

    ngAfterViewInit(): void {

    }


}
